import { render, staticRenderFns } from "./InfoTablePreferential.vue?vue&type=template&id=1d694b1a&scoped=true"
import script from "./InfoTablePreferential.vue?vue&type=script&lang=js"
export * from "./InfoTablePreferential.vue?vue&type=script&lang=js"
import style0 from "./InfoTablePreferential.vue?vue&type=style&index=0&id=1d694b1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d694b1a",
  null
  
)

export default component.exports